import { OrderItemDto } from "@deliverr/replenishment-client";
import { SPThunkAction } from "common/ReduxUtils";
import { getUnifiedProducts } from "common/wholesale-common/getUnifiedProducts";
import { keys, uniq } from "lodash";
import { mapOrderItemsToSelectedProducts } from "./utils/mapOrderItemsToSelectedProducts";
import { transferBulkAddProduct } from "transfers/create/actions";
import { getReplenishmentUnifiedInventory } from "../replenishment/warehouse-selection/actions/getReplenishmentUnifiedInventory";
import { updateOrderItemsLotNumber } from "./updateOrderItemsLotNumber";

export const loadProductsAndInventoryForTransfer =
  (orderItems: OrderItemDto[]): SPThunkAction<Promise<void>> =>
  async (dispatch) => {
    const productDskus = uniq(orderItems.map(({ packOf }) => packOf));

    const productCollection = await dispatch(getUnifiedProducts(productDskus));

    // TODO - Handle units sold last 30 days

    const selectedProducts = mapOrderItemsToSelectedProducts(orderItems, productCollection);

    dispatch(transferBulkAddProduct(selectedProducts));

    const selectedDskus = keys(selectedProducts);

    dispatch(updateOrderItemsLotNumber(orderItems));

    dispatch(getReplenishmentUnifiedInventory(selectedDskus));
  };
